export default __webpack_public_path__ + "static/cordy-53ca8dbad0bb182fccaa59dba97b8b97.webp";